"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CaretDownIconConfig = void 0;

var _createIcon = _interopRequireDefault(require("../createIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* This file is generated by createIcons.js any changes will be lost. */


var CaretDownIconConfig = {
  name: 'CaretDownIcon',
  height: 512,
  width: 320,
  svgPath: 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
exports.CaretDownIconConfig = CaretDownIconConfig;

var _default = (0, _createIcon["default"])(CaretDownIconConfig);

exports["default"] = _default;